if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }
    
    onSubmitHandler(evt) {
      evt.preventDefault();
      
      
        //   if(document.querySelector(".tom_tow-add_inscript")){var ti = document.querySelector(".tom_tow-add_inscript").value.trim(); var ti_first_lenght =  ti.length;}
        //   if(document.querySelector(".tom_tow-add_inscript_spursh")){var ti_spursh =  document.querySelector(".tom_tow-add_inscript_spursh").value.trim(); var ti_second_lenght =  ti_spursh.length;}
        //   //console.log(ti);
        //   if(document.querySelector('.add_inscription_checkbox_content input[type="checkbox"]')){
        //     var ch_box = document.querySelector('.add_inscription_checkbox_content input[type="checkbox"]').checked;}
          
        //   // if(ch_box == true){
        //   //   document.querySelector('.add_inscription_checkbox_content input[type="checkbox"]').classList.remove("tom_ai_disable");
        //   // }
        // var blank_array = [];
        // if(ch_box){
        //   //console.log(ti_spursh.length);
        //   if(ti == "" || ti_spursh == "" ){
        //     if(document.querySelector(".tom_ti_error")){document.querySelector(".tom_ti_error").innerHTML  = "Maximum number of characters: 20";
        //                                                 document.querySelector(".tom_ti_error").classList.add("apply-shake");
        //                                                setTimeout(() => {document.querySelector(".tom_ti_error").classList.remove("apply-shake");}, "1000"); }
        //     if(document.querySelector(".tom_ti_error_spurs")){document.querySelector(".tom_ti_error_spurs").innerHTML  = "Maximum number of characters: 40";
        //                                                       document.querySelector(".tom_ti_error_spurs").classList.toggle("apply-shake");
        //                                                      setTimeout(() => {document.querySelector(".tom_ti_error_spurs").classList.remove("apply-shake");}, "1000");}
        //     if(document.querySelector(".tom_ti_error")){document.querySelector(".tom_ti_error").style.display = 'block';}
        //     if(document.querySelector(".tom_ti_error_spurs")){document.querySelector(".tom_ti_error_spurs").style.display = 'block';}
        //     return false;
        //   }else if(ti_first_lenght > 20 || ti_second_lenght > 40){
        //     if(document.querySelector(".tom_ti_error")){document.querySelector(".tom_ti_error").innerHTML = "Please enter valid input";
        //                                                 document.querySelector(".tom_ti_error").classList.toggle("apply-shake");
        //                                                setTimeout(() => {document.querySelector(".tom_ti_error").classList.remove("apply-shake");}, "1000");}
        //     if(document.querySelector(".tom_ti_error")){document.querySelector(".tom_ti_error").style.display = 'block';}
        //     if(document.querySelector(".tom_ti_error_spurs")){document.querySelector(".tom_ti_error_spurs").innerHTML = "Please enter valid input";
        //                                                      document.querySelector(".tom_ti_error_spurs").classList.toggle("apply-shake");
        //                                                      setTimeout(() => {document.querySelector(".tom_ti_error_spurs").classList.remove("apply-shake");}, "1000");}
        //     if(document.querySelector(".tom_ti_error_spurs")){document.querySelector(".tom_ti_error_spurs").style.display = 'block';}
        //     return false;
        //   }
        //   else if(ti_first_lenght != ""){
        //     if(document.querySelector(".tom_ti_error")){document.querySelector(".tom_ti_error").style.display = 'none';}
        //     if(document.querySelector(".tom_ti_error_spurs")){document.querySelector(".tom_ti_error_spurs").style.display = 'none';}
        //   }

        //   // else if(ti_second_lenght > 40){
        //   //   if(document.querySelector(".tom_ti_error_spurs")){document.querySelector(".tom_ti_error_spurs").innerHTML = "Please enter valid input";}
        //   //   if(document.querySelector(".tom_ti_error_spurs")){document.querySelector(".tom_ti_error_spurs").style.display = 'block';}
        //   //   return false;
        //   // }

        //   var vid = document.querySelector('.add_inscription_checkbox_content input[type="checkbox"]').value;
        //   var qty = document.querySelector('.quantity input[name="quantity"]').value;
        //   // console.log("----", vid);
        //   // console.log("qty", qty);
        //   blank_array.push({id: vid, quantity: qty});
        //   console.log(blank_array); 
          
        // }
      

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
        config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
